'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { FETCH_MENUS, CREATE_MENU, DELETE_MENU, PUBLISH_MENU, RENAME_MENU, CLONE_MENU, REVERT_MENU, SELECT_MENU } from 'advanced-menus-core/actions/ActionTypes';
export function menusById(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case FETCH_MENUS:
      {
        const {
          menus
        } = action;
        if (menus) {
          const __menusById = menus.reduce((acc, menu) => {
            acc[menu.id] = menu;
            return acc;
          }, {});
          return SeamlessImmutable(__menusById);
        }
        return state;
      }
    case CREATE_MENU:
    case CLONE_MENU:
    case PUBLISH_MENU:
    case RENAME_MENU:
    case REVERT_MENU:
      {
        const {
          menu
        } = action;
        if (menu) {
          return state.set(menu.id, menu);
        }
        return state;
      }
    case DELETE_MENU:
      {
        const {
          menuId,
          deleted
        } = action;
        if (deleted) {
          return state.without(menuId);
        }
        return state;
      }
    default:
      {
        return state;
      }
  }
}
export function status(state = SeamlessImmutable({
  isFetching: null,
  fetchError: null,
  isPosting: null,
  postError: null,
  isDeleting: null,
  deleteError: null,
  isPublishing: null,
  publishError: null,
  isReverting: null,
  revertError: null
}), action) {
  switch (action.type) {
    case FETCH_MENUS:
      {
        const {
          menus,
          error
        } = action;
        return state.merge({
          isFetching: !(menus || error),
          fetchError: error || null
        });
      }
    case CREATE_MENU:
      {
        const {
          menu,
          error
        } = action;
        return state.merge({
          isPosting: !(menu || error),
          postError: error || null
        });
      }
    case PUBLISH_MENU:
      {
        const {
          menu,
          error
        } = action;
        return state.merge({
          isPublishing: !(menu || error),
          publishError: error || null
        });
      }
    case DELETE_MENU:
      {
        const {
          deleted,
          error
        } = action;
        return state.merge({
          isDeleting: !(deleted || error),
          deleteError: error || null
        });
      }
    case RENAME_MENU:
      {
        const {
          menu,
          error
        } = action;
        return state.merge({
          isDeleting: !(menu || error),
          deleteError: error || null
        });
      }
    case CLONE_MENU:
      {
        const {
          menu,
          error
        } = action;
        return state.merge({
          isCloning: !(menu || error),
          cloneError: error || null
        });
      }
    case REVERT_MENU:
      {
        const {
          menu,
          error
        } = action;
        return state.merge({
          isReverting: !(menu || error),
          revertError: error || null
        });
      }
    default:
      {
        return state;
      }
  }
}
export function currentlySelectedMenu(state = null, action) {
  switch (action.type) {
    // TODO: Remove this once we switch over to the deployable version of menus
    case SELECT_MENU:
      {
        const {
          menuId
        } = action;
        if (menuId) return menuId;
        return state;
      }
    case FETCH_MENUS:
      {
        const {
          menus,
          selectedMenuId
        } = action;
        if (selectedMenuId) return selectedMenuId;
        if (menus && menus.length) {
          const defaultMenu = menus.find(menu => menu.label === 'default');
          return defaultMenu && defaultMenu.id || menus[0].id;
        }
        return state;
      }
    case CLONE_MENU:
      {
        const {
          menu
        } = action;
        if (menu) {
          return menu.id;
        }
        return state;
      }
    default:
      {
        return state;
      }
  }
}
export default combineReducers({
  menusById,
  status,
  currentlySelectedMenu
});